import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { Pol } from './pol';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-pol',
  templateUrl: './pol.component.html'
 })
export class PolComponent extends BaseModalContainer<Pol> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Pol>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
